import classNames from 'classnames';
import React__default from 'react';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import Label from './Label.js';
import CheckIcon from '../Icons/CheckIcon.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../InfoIcon-2c4d43a3.js';
import '../Icons/InfoIcon.js';

var css_248z = ".uc2A2{opacity:0;position:absolute}[dir] .uc2A2{cursor:pointer}._2jFdZ{display:flex;gap:12px}[dir] ._2jFdZ{cursor:pointer}.ozoLY{display:flex}[dir] .YpbyR:hover i{border:1px solid rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.5)!important}.S5Od3:hover{opacity:.5}[dir] .S5Od3 i{background-color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))!important}.ffhzv{box-sizing:border-box;color:#fff;display:inline-block;height:16px;vertical-align:text-bottom;width:16px}[dir] .ffhzv{background-color:#fff;border:1px solid var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))!important;border-radius:3px;padding:3px 2px}.uc2A2:focus+.ffhzv{outline:thin dotted;outline:5px auto -webkit-focus-ring-color}.PGc1T{height:19px;vertical-align:text-bottom}[dir] .PGc1T{padding-top:2px}.PGc1T:hover{fill:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.5)}._63Y--{fill:#fff!important;color:#fff!important;display:block;height:8px;width:10px}[dir=ltr] ._2MiuZ{margin-left:12px}[dir=rtl] ._2MiuZ{margin-right:12px}";
var styles = {"checkbox_input":"uc2A2","checkbox":"_2jFdZ","checkbox_wrapper":"ozoLY","checkbox_inputLabel":"YpbyR","checkbox_inputLabel_checked":"S5Od3","checkbox_icon":"ffhzv","checkbox_infoIcon":"PGc1T","checkbox_check":"_63Y--","checkbox_label":"_2MiuZ"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class Checkbox extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = { focused: false };
    this.id = `chk_${Math.floor(Math.random() * 9999)}`;
  }
  onFocus() {
    this.setState({ focused: true });
  }
  onBlur() {
    this.setState({ focused: false });
  }
  render() {
    const {
      onChange,
      label,
      checked,
      dataHook,
      tooltipTextKey,
      t,
      isMobile,
      forceTooltipVisibility
    } = this.props;
    const a11yProps = {
      "aria-label": label,
      "aria-checked": checked,
      role: "checkbox"
    };
    return /* @__PURE__ */ React__default.createElement(
      "label",
      {
        htmlFor: this.id,
        className: classNames(styles.checkbox_wrapper, {
          [styles.checkbox]: true,
          [styles.focused]: this.state.focused
        })
      },
      /* @__PURE__ */ React__default.createElement(
        "div",
        {
          className: classNames(styles.checkbox_inputLabel, {
            [styles.checkbox_inputLabel_checked]: checked
          })
        },
        /* @__PURE__ */ React__default.createElement(
          "input",
          __spreadProps(__spreadValues({
            id: this.id,
            onFocus: () => this.onFocus(),
            onBlur: () => this.onBlur(),
            tabIndex: 0
          }, a11yProps), {
            className: styles.checkbox_input,
            type: "checkbox",
            "data-hook": dataHook,
            onChange,
            defaultChecked: checked
          })
        ),
        /* @__PURE__ */ React__default.createElement("i", { className: styles.checkbox_icon }, checked && /* @__PURE__ */ React__default.createElement(CheckIcon, { className: styles.checkbox_check }))
      ),
      /* @__PURE__ */ React__default.createElement(
        Label,
        {
          label,
          tooltipText: tooltipTextKey && t(tooltipTextKey),
          iconStyles: styles.checkbox_infoIcon,
          isMobile,
          forceTooltipVisibility
        }
      )
    );
  }
}
Checkbox.defaultProps = {
  checked: false,
  isMobile: false
};

export { Checkbox as default };
//# sourceMappingURL=Checkbox.js.map
